export default __webpack_public_path__ + "static/media/Shopify-App-Store-Badge.8192b727.png";